import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './constants';

const SUPPORTED = new Set(Object.values(SUPPORTED_LANGUAGES));

/**
 * Normalizes a merchant-supplied locale to a supported checkout language.
 * Unsupported values fall back to English.
 *
 * @param {string|null|undefined} raw
 * @returns {string|null} {@code en} | {@code pt_br}, or null when unset
 */
export const normalizeSessionLocale = (raw) => {
  if (raw == null || String(raw).trim() === '') {
    return null;
  }

  const normalized = String(raw).trim().toLowerCase().replace(/-/g, '_');

  if (SUPPORTED.has(normalized)) {
    return normalized;
  }

  if (normalized === 'pt' || normalized.startsWith('pt_')) {
    return SUPPORTED_LANGUAGES.PT_BR;
  }

  if (normalized.startsWith('en')) {
    return SUPPORTED_LANGUAGES.EN;
  }

  return DEFAULT_LANGUAGE;
};

/**
 * Resolves the language to use for checkout UI.
 * Falls back to English when the locale is missing or unsupported.
 *
 * @param {string|null|undefined} raw
 * @returns {string}
 */
export const resolveSessionLocale = (raw) =>
  normalizeSessionLocale(raw) || DEFAULT_LANGUAGE;
